module.exports = __webpack_public_path__ + "static/graduating-student-f98fb6edbdb628b7b77790410b449de3.jpg";